import { object, boolean } from "yup";
import { MANDATORY_FILED_VALIDATION_MESSAGE } from "shared/constants";

export const validationSchema = object().shape({
  activationMBSRadio: boolean().required(MANDATORY_FILED_VALIDATION_MESSAGE),
  activationMBSTV: boolean().required(MANDATORY_FILED_VALIDATION_MESSAGE),
});
